<div class="container">
    <div class="row">
        <div class="col-sm-12 marginBottom2Rem">
            <h4>Die folgenden Aktionen müssen noch freigegeben werden, damit Kunden sie nutzen können</h4>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-4 marginBottom2Rem">

            <form class="example-form" [formGroup]="filterForm">
                <mat-form-field class="full-width" appearance="fill">
                    <mat-label>Suche</mat-label>
                    <input type="email" matInput formControlName="search" placeholder="suchen.."
                        (change)="filterEvents()">
                    <mat-hint>Nach Aktionen suchen</mat-hint>
                </mat-form-field>
            </form>
        </div>
    </div>
    <div class="row">
        <div *ngIf="this.allEvents.length == 0 && loaded">
            <h4>Keine Aktion mit diesen Kriterien gefunden</h4>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-4 marginBottom2Rem" *ngFor="let event of allEvents">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <div mat-card-avatar *ngIf="event.eventPartner?.links[1] != undefined">
                        <img class="example-header-image" src='{{event.eventPartner?.links[1]?.href}}' alt="">
                    </div>
                    <div mat-card-avatar *ngIf="event.eventPartner?.links[1] == undefined">
                        <img class="example-header-image" src="../../../../../assets/placeholders/logo.svg" alt="">
                    </div>
                    <mat-card-title-group>
                        <mat-card-title>{{event.title | truncate: 18 : true}}</mat-card-title>
                        <mat-card-subtitle>{{event.eventPartner.name | truncate: 25 : true}}</mat-card-subtitle>
                    </mat-card-title-group>
                    <div fxFlex></div>
                    <button mat-icon-button class="margintopNegative16" [matMenuTriggerFor]="menu" color="accent"
                        >
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu" >
                        <button mat-menu-item (click)="activate(event)">
                            <span>Aktivieren</span>
                        </button>
                        <button mat-menu-item (click)="deactivate(event)">
                            <span>Ablehnen</span>
                        </button>
                        <button mat-menu-item (click)="moveToEdit(event)">
                            <span>Details ansehen</span>
                        </button>
                    </mat-menu>
                </mat-card-header>

                <img class="cardImage" *ngIf="event.image != null" mat-card-image src="{{event.image.url}}"
                    alt="Aktion_bild">
                <img class="cardImage" *ngIf="event.image == null" mat-card-image
                    src="../../../../../assets/placeholders/eventImage.png" alt="Aktion_bild">

                <mat-card-content>
                    <p class="eventDescription">
                        {{event.escapedDescription | truncate: 150 : false }}
                    </p>
                    <mat-divider></mat-divider>
                    <div class="quickFactsContainer">
                        <div class="flexCenter">
                            <mat-icon aria-hidden="false">date_range</mat-icon>
                            <h5 *ngIf="event.startDate != null">{{event.startDate | date:'dd.MM.yyyy'}} -
                                {{event.endDate | date:'dd.MM.yyyy'}}</h5>
                            <h5 *ngIf="event.startDate == null">Unbegrenzt</h5>
                        </div>
                        <div class="flexCenter">
                            <mat-icon aria-hidden="false">chrome_reader_mode</mat-icon>
                            <h5>{{event.totalActiveReservationsCount}} Reservierungen</h5>
                        </div>
                        <div class="flexCenter">
                            <mat-icon aria-hidden="false">card_giftcard</mat-icon>
                            <h5>{{event.availableVoucherKeyCount}} verfügbare Gutscheincodes</h5>
                        </div>
                    </div>
                    <mat-divider></mat-divider>
                    <h6 class="subHeading">Kategorien</h6>
                    <mat-chip-set>
                        <mat-chip color="warn" selected>{{event.state | translateState}}</mat-chip>
                        <mat-chip *ngFor="let category of event.interests| slice:0:2">{{category.name}}</mat-chip>
                    </mat-chip-set>
                    <mat-divider></mat-divider>
                </mat-card-content>
                <mat-card-actions>
                    <button mat-button color="accent" (click)="deactivate(event)">Ablehnen</button>
                    <button mat-button color="accent" (click)="activate(event)">Aktivieren</button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>
    <mat-paginator [length]="page.totalElements" class="paginator-centered" [pageSize]="page.size"
        [pageIndex]="page.number" (page)="loadPage($event)" [pageSizeOptions]="[12, 24, 36, 48]" *ngIf="page">
    </mat-paginator>
</div>